import React from "react";
import { Element } from "react-scroll";

import {
  MainColumn,
  PageSection,
  GridContainer,
  SidebarColumn,
} from "./layout";
import Sidebar from "./sidebar";
import Summary from "./summary";
import IntroHeader from "./intro";
import Accordion from "./accordion";
import Highlights from "./highlights";
import WorkTimeline from "./timeline";
import EducationSection from "./education";
import ExperienceSection from "./experience";
import SkillCategoriesSection from "./skills";
import CertificationsSection from "./certifications";

export default function ResumeSection({ compensateHeaderGap = false }) {
  return (
    <PageSection as={Element} name="resume">
      <GridContainer $compensateHeaderGap={compensateHeaderGap}>
        <SidebarColumn>
          <Sidebar />
        </SidebarColumn>
        <MainColumn>
          <IntroHeader />
          <Summary />
          <Highlights />
          {/* Accordions */}
          <Accordion title="Work experience" id="WorkExperience">
            <WorkTimeline />
          </Accordion>
          <Accordion title="Experience" id="Experience">
            <ExperienceSection />
          </Accordion>
          <Accordion title="Education" id="EducationAndCertifications">
            <EducationSection />
          </Accordion>
          <Accordion title="Certifications">
            <CertificationsSection />
          </Accordion>
          <Accordion title="Skills" id="Skills">
            <SkillCategoriesSection />
          </Accordion>
        </MainColumn>
      </GridContainer>
    </PageSection>
  );
}
